/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkCenterQaHistoryParameter } from '../../models/work-center-qa-history-parameter';

export interface GetQaHistoryParameterValue$Params {
  workCenterId: number;
}

export function getQaHistoryParameterValue(http: HttpClient, rootUrl: string, params: GetQaHistoryParameterValue$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkCenterQaHistoryParameter>> {
  const rb = new RequestBuilder(rootUrl, getQaHistoryParameterValue.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkCenterQaHistoryParameter>;
    })
  );
}

getQaHistoryParameterValue.PATH = '/api/v1/WorkCenter/{workCenterId}/QaHistoryParameterValue';
